import getEnv from "./getEnv";
import { Environ } from "./types";

const isDev = (): boolean => {
  return getEnv() === Environ.DEV;
};

export default isDev;
